import { message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import authService from 'service/authService';

interface LoginHandlersHook {
  navigate: NavigateFunction;
  setLoading: (loading: boolean) => void;
  redirectPath?: string;
}

interface LoginHandlersReturn {
  onFinish: (values: { username: string; password: string }) => Promise<void>;
}

export const getLoginHandlers = ({
  navigate,
  setLoading,
  redirectPath,
}: LoginHandlersHook): LoginHandlersReturn => {
  const onFinish = async (values: { username: string; password: string }): Promise<void> => {
    setLoading(true);
    try {
      await authService.login(values.username, values.password);
      message.success('Login success');

      const destination = redirectPath && redirectPath !== '/login' ? redirectPath : '/main';
      if (window.location.pathname !== destination) {
        navigate(destination);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return { onFinish };
};
